import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SPOTButton } from "spot-component-library/lib/components/SPOTButton";
import { Panel } from "spot-component-library/lib/components/basic/panel/Panel";
import { PageTitle } from "../../components/PageTitle/PageTitle";
import "./ErrorPage.scss";

type ErrorCode = string;

interface ErrorPageProp {
    errorCode?: ErrorCode;
    onPrimaryButtonClick?: () => void;
    onSecondaryButtonClick?: () => void;
}

export const ErrorPage = (props: ErrorPageProp) => {
    const { errorCode, onPrimaryButtonClick, onSecondaryButtonClick } = props;

    const { t } = useTranslation();

    const errorText = useMemo(() => mapErrorCodeToErrorMessage(errorCode), [errorCode]);

    return (
        <div className="error-page" data-test="error-page">
            <PageTitle icon="icon-cancel-V2" iconColor="error" title={t(`ERROR_PAGE.TITLE`)} />

            <Panel>
                <div className="panel-content">
                    <h3>{t(`${errorText}.TITLE`)}</h3>
                    <p className={"error-message"}>{t(`${errorText}.BODY`)}</p>
                </div>
            </Panel>

            {onPrimaryButtonClick && (
                <div className="button-wrapper">
                    <SPOTButton label={t(`${errorText}.PRIMARY_BUTTON_LABEL`)} type="primary" onClick={onPrimaryButtonClick} />
                </div>
            )}

            {onSecondaryButtonClick && (
                <div className="button-wrapper">
                    <SPOTButton label={t(`${errorText}.SECONDARY_BUTTON_LABEL`)} type="secondary" onClick={onSecondaryButtonClick} />
                </div>
            )}
        </div>
    );
};

/**
 * Maps computops 8-digit error to user friendly error message.
 * @see https://developer.computop.com/display/DE/A4+Fehlercodes
 */
function mapErrorCodeToErrorMessage(errorCode?: ErrorCode) {
    if (!errorCode) {
        return "ERROR_PAGE.MESSAGES.DEFAULT";
    }

    const errorCodeModule = errorCode.substring(1, 4);

    switch (errorCodeModule) {
        case "150":
            return "ERROR_PAGE.MESSAGES.PAYPAL";

        default:
            return "ERROR_PAGE.MESSAGES.DEFAULT";
    }
}
